import * as React from "react"
import { GatsbyBrowser } from "gatsby"
export { wrapPageElement } from "./wrap-page-element"
import { GA_TRACKING_ID } from "../../src/config/analytics"

import { initGoogleAnalytics } from "@ucam.uis.devops/ucam-observe-remote-analytics"
import { MyCAppRoot } from "./Root"

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => {
  return <MyCAppRoot>{element}</MyCAppRoot>
}

const isGoogleAnalyticsId = (id: string) => /^G-[A-Za-z0-9]+$/i.test(id)

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  if (typeof window !== "undefined" && isGoogleAnalyticsId(GA_TRACKING_ID)) {
    initGoogleAnalytics(GA_TRACKING_ID || "")
  }
}
